import { render, staticRenderFns } from "./MyPrize.vue?vue&type=template&id=49423f10&scoped=true&"
import script from "./MyPrize.vue?vue&type=script&lang=js&"
export * from "./MyPrize.vue?vue&type=script&lang=js&"
import style0 from "./MyPrize.vue?vue&type=style&index=0&id=49423f10&lang=scss&scoped=true&"
import style1 from "./MyPrize.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49423f10",
  null
  
)

export default component.exports